import { Identifiable, Project } from "@planzone/dto";
import { Filter } from "@planzone/dto";

function isFilteredByStatuses(
  { status }: Identifiable<Project>,
  { projectStatuses }: Filter,
): boolean {
  return (
    !!projectStatuses &&
    !!status &&
    projectStatuses.length > 0 &&
    !projectStatuses.find(({ uuid }) => uuid === status.uuid)
  );
}

export { isFilteredByStatuses };
